<template>
  <div class="base-input" :class="{ error: hasValidationError }" :style="{ width }">
    <label
      v-if="label"
      @click="() => !readonly && $refs.input.focus()"
      :class="['input__label', { readonly, disabled }]"
      >{{ label }}</label
    >
    <textarea
      autocomplete="off"
      ref="input"
      v-model="inputValue"
      @focus="$emit('focus')"
      @blur="handleBlur"
      :name="name"
      :placeholder="readonly ? '-' : placeholder"
      class="input__field"
      :readonly="readonly"
      :disabled="loading"
      :maxlength="limitMaxLength"
    />
    <slot
      v-if="hasValidationError && !serverValidationPending"
      class="validation-messages"
    />
  </div>
</template>

<script>
import Base from './Base/Base.vue'

export default {
  name: 'vtextarea',
  extends: Base,
  methods: {
    handleBlur () {
      this.$emit('blur')
      this.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/system/_vars';
@import '@/assets/css/system/_mixins';

textarea {
  resize: none;
  height: 127px;
  // overflow: hidden scroll;
  max-width: 100%;
  scrollbar-width: none;
  scrollbar-color: transparent;
  padding: 12px;
}

.readonly-block {
  word-break: break-word;
  line-height: 150%;
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-button {
  height: 8px;
  opacity: 0;
}

::-webkit-scrollbar-track {
  background: linear-gradient(90deg, $border-color 0%, $border-color 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(90deg, $color_second-light 0%, $color_second-light 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
}
</style>
